import React from "react";
import "./MSSeparator.css";
import { Image as BoostrapImage } from "react-bootstrap";
import PildoraMS from "../PildoraMS/PildoraMS";

export const MSSeparator = ({ children, className }) => {
  return (
    <div className={`MSSeparatorContainer ${className}`}>
      {children}
    </div>
  );
};

const Image = ({ src, alt, width = 302, height = 65 }) => (
  <BoostrapImage src={src} alt={alt} width={width} height={height} />
);
const Title = ({ children, ...props }) => (
  <h2 className="MSSeparatorTitle" {...props}>{children}</h2>
);
const ItemsList = ({ items, onPildoraClick }) => (
  <div className="MSSeparatorList">
    {items.map((item, idx) => (
      <PildoraMS 
        key={`MSSeparatorItem-${idx}-${item.text}`}
        numOfSpecializations={item.numOfSpecializations}
        specializations={item.specializations || []}
        onClick={onPildoraClick}
      >
        {item.text}
      </PildoraMS>
    ))}
  </div>
);

const MemoizedItemsList = React.memo(ItemsList);
MSSeparator.Image = Image;
MSSeparator.Title = Title;
MSSeparator.ItemsList = MemoizedItemsList;
